import { Routes, Route, Navigate } from 'react-router-dom';

import { InviteLanding } from './pages/InviteLanding';
import { Login } from './pages/Login';
import { Signup } from './pages/Signup';
import { ForgotPassword } from './pages/ForgotPassword';
import { ResetPassword } from './pages/ResetPassword';
import { Dashboard } from './pages/Dashboard';
import { PumpDetail } from './pages/PumpDetail';
import { Profile } from './pages/Profile';
import { CollabJoinPage } from './pages/CollabJoinPage';
import { NotificationsPage } from './pages/NotificationsPage';
import { Support } from './pages/Support';
import { RequireAuth } from './components/RequireAuth';

export default function App() {
  return (
    <Routes>
      {/* Public — no auth gate */}
      <Route path="/invite/:token" element={<InviteLanding />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      {/* Authed */}
      <Route
        path="/dashboard"
        element={
          <RequireAuth>
            <Dashboard />
          </RequireAuth>
        }
      />
      <Route
        path="/pump/:deviceId"
        element={
          <RequireAuth>
            <PumpDetail />
          </RequireAuth>
        }
      />
      <Route
        path="/profile"
        element={
          <RequireAuth>
            <Profile />
          </RequireAuth>
        }
      />

      {/* Support — customer issue tracker (report a problem + my issues). */}
      <Route
        path="/support"
        element={
          <RequireAuth>
            <Support />
          </RequireAuth>
        }
      />
      <Route
        path="/support/:issueId"
        element={
          <RequireAuth>
            <Support />
          </RequireAuth>
        }
      />

      {/* Collab — join-only meeting page. Not in nav; reached via notification
          or direct deep link. Route not guarded with RequireAuth because the
          page itself shows a "no access" state — but the API calls will 401
          if unauthenticated. */}
      <Route
        path="/collab/:roomId"
        element={
          <RequireAuth>
            <CollabJoinPage />
          </RequireAuth>
        }
      />

      {/* Notifications inbox — P1-62 scoped subset (meeting invites only). */}
      <Route
        path="/notifications"
        element={
          <RequireAuth>
            <NotificationsPage />
          </RequireAuth>
        }
      />

      {/* Default — kicks the user toward auth-gated dashboard, which
          itself bounces to /login if needed. */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
